export enum GeneralFileNodeType {
  FILE = "FILE",
  FOLDER = "FOLDER",
  URL = "URL",
}
